import { render, staticRenderFns } from "./OrganizerAppPrint.vue?vue&type=template&id=068be920&"
import script from "./OrganizerAppPrint.vue?vue&type=script&lang=js&"
export * from "./OrganizerAppPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports